<template>
  <div class="text-xs-center" v-if="config.format == 'chip'">
    <v-chip
      v-for="(user, user_id) in users"
      :key="user_id"
      color="grey lighten"
      text-color="white"
    >{{ user.displayName }}</v-chip>
  </div>
  <span v-else-if="config.format == 'list'">
    <span v-for="(user, user_id) in users" :key="user_id">
      <span>{{ user.displayName }}</span>
      <span v-if="user_id < users.length - 1">,&nbsp;</span>
    </span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/users";
// import user_resolver from "@/utils/user_resolver";

export default {
  props: {
    currentUsers: {
      type: [Array, String],
      default: () => []
    }
  },
  data() {
    return {
      config: {
        displayName: "displayName",
        email: "email",
        avatar: "avatar",
        format: "list" // chip,list,more to come
      }
    };
  },
  methods: {
    mapUsers(userlist) {
      // TODO: Inperformant -> Join sollte Serverseitig laufen. Check ob es im Anwendungsfall ausreicht
      let users = [];

      if (typeof this.currentUsers === "object") {
        for (let user in userlist) {
          let user_id = userlist[user];
          let user_object = this.getUser(user_id) || {
            id: user_id,
            displayName: user_id
          };
          users.push(user_object);
        }
      } else {
        let user = userlist;
        let user_object = this.getUser(user) || { id: user, displayName: user };
        users.push(user_object);
      }
      return users;
    }
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.getUser]),
    users() {
      return this.mapUsers(this.currentUsers);
    }
  }
};
</script>
